import { Property } from "./Property";

export class Plant {
  public type: string = "";
  public property: Property = new Property(0);

  public constructor(public id: number) {}
}
